import {isFeatureEnabled} from 'feature-flags';

import {BusinessCaseInternalType} from '@dms/api/sales';
import {featureFlags} from '@dms/feature-flags';

import {Nullish} from 'shared/web';

interface BuyingOnlineOfferActionPermissionsParams {
  businessCaseInternalType: BusinessCaseInternalType | Nullish;
  businessCaseState: string | Nullish;
  isOnlineOfferCreated: boolean;
  isOnlineOfferSent: boolean;
  canSendBuyingOnlineOffer: boolean;
  canInvalidateBuyingOnlineOffer: boolean;
}

export const getBuyingOnlineOfferActionPermissions = (
  params: BuyingOnlineOfferActionPermissionsParams
) => {
  const isBuyingOnlineOfferEnabled =
    isFeatureEnabled(featureFlags.BUYING_ONLINE_OFFER) &&
    params.businessCaseInternalType === 'BUYING';
  const isBusinessCaseInCorrectState =
    params.businessCaseState !== 'CONCEPT' && params.businessCaseState !== 'UNSUCCESSFUL';
  const canManageBuyingOnlineOffer = isBuyingOnlineOfferEnabled && isBusinessCaseInCorrectState;

  return {
    isBuyingOnlineOfferEnabled,
    canOpenOnlineOffer: canManageBuyingOnlineOffer && params.canSendBuyingOnlineOffer,
    canSendOffer:
      canManageBuyingOnlineOffer && params.canSendBuyingOnlineOffer && !params.isOnlineOfferSent,
    canResendOffer:
      canManageBuyingOnlineOffer && params.canSendBuyingOnlineOffer && params.isOnlineOfferSent,
    canInvalidateOffer:
      isBuyingOnlineOfferEnabled &&
      params.canInvalidateBuyingOnlineOffer &&
      params.isOnlineOfferCreated &&
      params.isOnlineOfferSent,
  };
};
